const commonAr = {
    common: require('../../lang/ar/common/Common').default,
};

export default commonAr;